var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        _vm.parts.card,
        {
          tag: "component"
        },
        [
          _c(
            _vm.parts.header,
            {
              tag: "component",
              class: _vm.headerClass
            },
            [_vm._v("Restrictions")]
          ),
          _c(
            _vm.parts.text,
            {
              tag: "component"
            },
            [
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: {
                  color: "green",
                  "true-value": _vm.ALLOW,
                  "false-value": _vm.SUSPEND,
                  loading: _vm.pending.incoming,
                  disabled: _vm.busy,
                  label: "Receive incoming mail",
                  "hide-details": ""
                },
                on: {
                  change: function change($event) {
                    return _vm.setRestriction("incoming", $event)
                  }
                },
                model: {
                  value: _vm.restrictions.incoming,
                  callback: function callback($$v) {
                    _vm.$set(_vm.restrictions, "incoming", $$v)
                  },
                  expression: "restrictions.incoming"
                }
              }),
              _c(
                "div",
                {
                  staticClass: "mt-6"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "body-2 font-weight-medium"
                    },
                    [_vm._v("Sending outgoing email")]
                  ),
                  _c(
                    "v-radio-group",
                    {
                      staticClass: "mt-1",
                      attrs: {
                        row: "",
                        disabled: _vm.busy,
                        "hide-details": ""
                      },
                      on: {
                        change: function change($event) {
                          return _vm.setRestriction("outgoing", $event)
                        }
                      },
                      model: {
                        value: _vm.restrictions.outgoing,
                        callback: function callback($$v) {
                          _vm.$set(_vm.restrictions, "outgoing", $$v)
                        },
                        expression: "restrictions.outgoing"
                      }
                    },
                    [
                      _c("v-radio", {
                        attrs: {
                          color: "green",
                          label: "Allow",
                          value: _vm.ALLOW
                        }
                      }),
                      _c("v-radio", {
                        attrs: {
                          color: "green",
                          label: "Suspend",
                          value: _vm.SUSPEND
                        }
                      }),
                      _c("v-radio", {
                        attrs: {
                          color: "green",
                          label: "Hold",
                          value: _vm.HOLD
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "p",
                    {
                      staticClass: "body-2 text--secondary mt-2 mb-0"
                    },
                    [
                      _vm._v(
                        " Suspend rejects outgoing mail. Hold queues it until sending is allowed again. "
                      )
                    ]
                  )
                ],
                1
              ),
              _c("v-switch", {
                staticClass: "mt-6",
                attrs: {
                  color: "green",
                  "true-value": _vm.ALLOW,
                  "false-value": _vm.SUSPEND,
                  loading: _vm.pending.login,
                  disabled: _vm.busy,
                  label: "Allow logging in",
                  "hide-details": ""
                },
                on: {
                  change: function change($event) {
                    return _vm.setRestriction("login", $event)
                  }
                },
                model: {
                  value: _vm.restrictions.login,
                  callback: function callback($$v) {
                    _vm.$set(_vm.restrictions, "login", $$v)
                  },
                  expression: "restrictions.login"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm.embedded
        ? _c("v-divider", {
            staticClass: "my-6"
          })
        : _vm._e(),
      _c(
        _vm.parts.card,
        {
          tag: "component",
          class: {
            "mt-6": !_vm.embedded
          }
        },
        [
          _c(
            _vm.parts.header,
            {
              tag: "component",
              class: _vm.headerClass
            },
            [_vm._v("Plus Addressing")]
          ),
          _c(
            _vm.parts.text,
            {
              tag: "component"
            },
            [
              _vm.autocreate === null && _vm.pending.autocreate
                ? _c("gg-loading", {
                    attrs: {
                      loading: true,
                      type: "list-item"
                    }
                  })
                : _vm.autocreate === null
                ? _c(
                    "p",
                    {
                      staticClass: "body-2 mb-0"
                    },
                    [_vm._v(" This setting isn't available right now. ")]
                  )
                : [
                    _c("v-switch", {
                      staticClass: "mt-0",
                      attrs: {
                        color: "green",
                        loading: _vm.pending.autocreate,
                        disabled: _vm.pending.autocreate,
                        label:
                          "Automatically create folders for plus addressing",
                        "hide-details": ""
                      },
                      on: {
                        change: _vm.setAutocreate
                      },
                      model: {
                        value: _vm.autocreate,
                        callback: function callback($$v) {
                          _vm.autocreate = $$v
                        },
                        expression: "autocreate"
                      }
                    }),
                    _c(
                      "p",
                      {
                        staticClass: "body-2 text--secondary mt-2 mb-0"
                      },
                      [
                        _vm._v(
                          " Mail sent to " +
                            _vm._s(_vm.plusExample) +
                            " is filed into a folder named “folder”, created automatically if it doesn't exist. "
                        )
                      ]
                    )
                  ]
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }